import { cn, fmtInterval } from '@/shared/lib'
import { Checkbox } from '@/shared/ui/checkbox'
import type { Task } from '../model/schema'

interface TaskRowProps {
  task: Task
  onToggle: (task: Task) => void
  onOpen: (task: Task) => void
}

/** Строка списка дел (панель «без времени» и список у выхода). */
export function TaskRow({ task, onToggle, onOpen }: TaskRowProps) {
  return (
    <li className="flex items-center gap-3 rounded-control px-2 py-2 hover:bg-bg-elevated">
      <Checkbox
        checked={task.done}
        onChange={() => onToggle(task)}
        aria-label={task.done ? `Вернуть в работу: ${task.title}` : `Отметить: ${task.title}`}
      />
      <button
        type="button"
        onClick={() => onOpen(task)}
        className="flex min-w-0 flex-1 flex-col items-start text-left"
      >
        <span
          className={cn(
            'truncate text-sm',
            task.done ? 'text-text-tertiary line-through' : 'text-text-primary',
          )}
        >
          {task.title}
        </span>
        {task.slot && (
          <span className="mono-num text-[11px] text-text-tertiary">{fmtInterval(task.slot)}</span>
        )}
      </button>
    </li>
  )
}
